import React, { useRef, useEffect, useState } from "react";
import { gsap } from "gsap";
import { useMediaQuery } from "react-responsive";

import Modal from "./Modal";

import bg_slots from "./assets/img/canvas/osn.png";
import title_slots from "./assets/img/canvas/title.png";
import img1 from "./assets/img/canvas/slot1.png";
import img2 from "./assets/img/canvas/slot3.png";
import img3 from "./assets/img/canvas/slot4.png";
import img4 from "./assets/img/canvas/slot6.png";
import img5 from "./assets/img/canvas/slot7.png";
import img6 from "./assets/img/canvas/slot9.png";
import btn_img from "./assets/img/canvas/btn.png";

import "./Slots.css";
function Slots() {
	const xs = useMediaQuery({
		query: "(min-width: 0px) and (max-width: 767.98px)",
	});
	const md = useMediaQuery({
		query: "(min-width: 768px) and (max-width: 991.98px)",
	});
	const lg = useMediaQuery({
		query: "(min-width: 992px) and (max-width: 1169.98px)",
	});
	const xl = useMediaQuery({
		query: "(min-width: 1170px)",
	});
	const slots1 = useRef(null);
	const slots2 = useRef(null);
	const slots3 = useRef(null);

	const modal = useRef(null);

	var SLOTS_RESPONSE = {
		mobile: {
			slot: [
				{
					top: 29,
					left: 20,
					breakpoint: count === 0 ? -330 : count === 1 ? -131 : -396,
				},
				{
					top: 29,
					left: 109,
					breakpoint: count === 0 ? -133 : count === 1 ? -198 : -330,
				},
				{
					top: 29,
					right: 19,
					breakpoint: count === 0 ? -265 : count === 1 ? -330 : -66,
				},
			],
			slot_height: 191,
			slot_width: 82,
			y: -396,
			gap: 6,
			img: { h: 60, w: 72 },
			height: 250,
			width: 300,
		},
		desktop: {
			slot: [
				{
					top: 9,
					left: 64,
					breakpoint: count === 0 ? -700 : count === 1 ? -273 : -833,
				},
				{
					top: 9,
					left: 261,
					breakpoint: count === 0 ? -280 : count === 1 ? -415 : -697,
				},
				{
					top: 9,
					right: 60,
					breakpoint: count === 0 ? -553 : count === 1 ? -695 : -134,
				},
			],
			slot_height: 421,
			slot_width: 182,
			y: -835,
			gap: 10,
			img: { h: 130, w: 150 },
			height: 440,
			width: 700,
		},
	};

	var anim1;
	var anim2;
	var anim3;

	var [count, setCount] = useState(0);
	var [isOpenModal, setOpenModal] = useState(false);
	var [isStoping, setIsStoping] = useState(false);

	useEffect(() => {
		if (!isStoping) {
			anim1 = gsap.fromTo(
				slots1.current,
				{ y: xs ? SLOTS_RESPONSE.mobile.y : SLOTS_RESPONSE.desktop.y },
				{
					translateY: "0",
					duration: 0.7,
					repeat: -1,
					ease: "none",
					onComplete: () => {},
					onStart: () => {},
				}
			);
			anim2 = gsap.fromTo(
				slots2.current,
				{ y: xs ? SLOTS_RESPONSE.mobile.y : SLOTS_RESPONSE.desktop.y },
				{
					translateY: "0",
					duration: 0.7,
					repeat: -1,
					ease: "none",
				}
			);
			anim3 = gsap.fromTo(
				slots3.current,
				{ y: xs ? SLOTS_RESPONSE.mobile.y : SLOTS_RESPONSE.desktop.y },
				{
					translateY: "0",
					duration: 0.7,
					repeat: -1,
					ease: "none",
				}
			);
		}
	});

	function stopAnim() {
		if (!isStoping) {
			setCount(count + 1);
			setIsStoping(true);
			console.log(anim1.pause());
			gsap.to(slots1.current, {
				y: 0,
				duration: 0.7,
				ease: "none",
				repeat: 0,
				onStart: () => {
					// console.log(
					//   getComputedStyle(slots1.current)
					//     .getPropertyValue("transform")
					//     .match(/(-?[0-9\.]+)/g)[5]
					// );
				},
				onComplete: () => {
					gsap.to(slots1.current, {
						y: -396,
						ease: "none",
						repeat: 0,
						duration: 0,
						onComplete: () => {
							gsap.fromTo(
								slots1.current,
								{ y: xs ? SLOTS_RESPONSE.mobile.y : SLOTS_RESPONSE.desktop.y },
								{
									// y: -633
									y: xs
										? count === 0
											? -330
											: count === 1
											? -131
											: -396
										: count === 0
										? -700
										: count === 1
										? -273
										: -833,
									// TODO:
									duration:
										0.7 +
										(1 -
											(-1 *
												(xs
													? count === 0
														? -330
														: count === 1
														? -131
														: -396
													: count === 0
													? -700
													: count === 1
													? -273
													: -833)) /
												((-1 *
													(xs
														? SLOTS_RESPONSE.mobile.y
														: SLOTS_RESPONSE.desktop.y)) /
													100) /
												100),
									// duration: 0.28688741721854305,
									// ease: "circ.out",
									ease: "power1.out",
									repeat: 0,
									onStart: () => {
										anim2.pause();
										gsap.to(slots2.current, {
											y: "0",
											duration: 0.7,
											ease: "none",
											repeat: 0,
											onComplete: () => {
												gsap.to(slots2.current, {
													y: "-396",
													ease: "none",
													repeat: 0,
													duration: 0,
													onComplete: () => {
														gsap.fromTo(
															slots2.current,
															{
																y: xs
																	? SLOTS_RESPONSE.mobile.y
																	: SLOTS_RESPONSE.desktop.y,
															},
															{
																// y: -633
																y: xs
																	? count === 0
																		? -133
																		: count === 1
																		? -198
																		: -330
																	: count === 0
																	? -280
																	: count === 1
																	? -415
																	: -697,
																// TODO:
																duration:
																	0.7 +
																	(1 -
																		(-1 *
																			(xs
																				? count === 0
																					? -133
																					: count === 1
																					? -198
																					: -330
																				: count === 0
																				? -280
																				: count === 1
																				? -415
																				: -697)) /
																			((-1 *
																				(xs
																					? SLOTS_RESPONSE.mobile.y
																					: SLOTS_RESPONSE.desktop.y)) /
																				100) /
																			100),
																ease: "power1.out",
																// ease: "circ.out",
																repeat: 0,
																onStart: () => {
																	anim3.pause();
																	gsap.to(slots3.current, {
																		y: "0",
																		duration: 0.7,
																		ease: "none",
																		repeat: 0,
																		onComplete: () => {
																			gsap.to(slots3.current, {
																				y: "-396px",
																				ease: "none",
																				repeat: 0,
																				duration: 0,
																				onComplete: () => {
																					gsap.fromTo(
																						slots3.current,
																						{
																							y: xs
																								? SLOTS_RESPONSE.mobile.y
																								: SLOTS_RESPONSE.desktop.y,
																						},
																						{
																							// y: -633
																							y: xs
																								? count === 0
																									? -265
																									: count === 1
																									? -330
																									: -66
																								: count === 0
																								? -553
																								: count === 1
																								? -695
																								: -134,
																							// TODO:
																							duration:
																								0.7 +
																								(1 -
																									(-1 *
																										(xs
																											? count === 0
																												? -265
																												: count === 1
																												? -330
																												: -66
																											: count === 0
																											? -553
																											: count === 1
																											? -695
																											: -134)) /
																										((-1 *
																											(xs
																												? SLOTS_RESPONSE.mobile
																														.y
																												: SLOTS_RESPONSE.desktop
																														.y)) /
																											100) /
																										100),
																							// ease: "circ.out",
																							ease: "power1.out",
																							repeat: 0,
																							onComplete: () => {
																								setOpenModal(true);
																								// gsap.fromTo(
																								//   modal.current,
																								//   { opacity: 0 },
																								//   { opacity: 1, duration: 0.2 }
																								// );
																							},
																						}
																					);
																				},
																			});
																		},
																	});
																},
															}
														);
													},
												});
											},
										});
									},
								}
							);
						},
					});
				},
			});
		}
	}
	let slotArr = [
		[img1, img2, img3, img4, img5, img6, img1, img2, img3],
		[img5, img4, img2, img6, img1, img3, img5, img4, img2],
		[img2, img5, img4, img3, img6, img1, img2, img5, img4],
	];
	function handlerModal() {
		// setOpenModal(!isOpenModal);
	}
	function animsPlay() {
		setIsStoping(false);
	}
	// любой бред первая -495 вторая -495 третья -240
	// 777 первая -750 вторая -625 третья -115
	// TODO:
	const styles = {
		title: {
			filter: "drop-shadow(0 0 15px black)",
			color: "#fff",
			textShadow: "2px 2px 0 #6f1400",
			textTransform: "uppercase",
			lineHeight: 1,
			paddingLeft: 20,
			fontFamily: "Uni Sans",
			fontStyle: "italic",
			fontWeight: 900,
			textAlign: xs ? "center" : "right",
			fontSize: xs ? 35 : md ? 80 : 70,
			marginTop: xs ? 6 : md ? 10 : 0,
			marginBottom: 15,
		},
		slots: {
			width: xs ? SLOTS_RESPONSE.mobile.width : SLOTS_RESPONSE.desktop.width,
			height: xs ? SLOTS_RESPONSE.mobile.height : SLOTS_RESPONSE.desktop.height,
			backgroundSize: "cover",
			backgroundRepeat: "no-repeat",
			backgroundPosition: "center",
			position: "relative",
			backgroundImage: `url(${bg_slots})`,
			title: {
				textAlign: "center",
				textTransform: "uppercase",
				color: "#D71015",
				fontFamily: "TT Squares Condensed",
				fontStyle: "italic",
				fontWeight: 900,
				fontSize: 40,
				textShadow:
					"2px 0 #fff, -2px 0 #fff, 0 2px #fff, 0 -2px #fff, 2px 2px #fff, -2px -2px #fff, -2px 2px #fff, 2px -2px #fff",
				count: {
					backgroundColor: "#fff",
					transform: "skew(-30deg)",
					fontSize: xs ? 25 : 35,
					width: "fit-content",
					textTransform: "uppercase",
					fontFamily: "Uni Sans",
					fontStyle: "italic",
					fontWeight: 900,
					padding: xs ? "2px 10px" : "2px 20px",
					marginBottom: xs ? 0 : 20,
				},
			},
			col: {
				position: "absolute",
				// backgroundColor: "#ccc",
				height: xs
					? SLOTS_RESPONSE.mobile.slot_height
					: SLOTS_RESPONSE.desktop.slot_height,
				width: xs
					? SLOTS_RESPONSE.mobile.slot_width
					: SLOTS_RESPONSE.desktop.slot_width,
				overflow: "hidden",
				display: "flex",
				flexDirection: "column",
				alignItems: "center",
			},
			btn: {
				marginTop: xs ? 0 : 50,
				width: xs ? 300 : 650,
				height: xs ? 40 : 104,
				cursor: "pointer",
				background:
					"linear-gradient(180deg, #CA0E12 0%, #FD4A4F 46.14%, #C40E13 100%)",
				borderRadius: 7,
				// boxShadow: isMouseActive
				//   ? "0px 0px 35px #D71015, inset 0px 4px 20px rgba(0, 0, 0, 0.8)"
				//   : isMouseHover
				//   ? "0px 0px 35px #D71015"
				//   : "0px 12px 15px rgba(0, 0, 0, 0.3)",
				fontFamily: "Uni Sans",
				fontStyle: "italic",
				fontWeight: 900,
				fontSize: xs ? 27 : 70,
				color: "#fff",
				display: "flex",
				justifyContent: "center",
				alignItems: "center",
				position: "relative",
				// transition: "0.5s",
			},
			modal: {
				display: "none",
				opacity: 0,
				transition: 0.3,
				modalOpen: {
					display: "flex",
					opacity: 1,
					transition: 0.3,
				},
			},
		},
	};
	return (
		<div
			style={{
				display: "flex",
				flexDirection: "column",
				alignItems: "center",
				justifyContent: "space-evenly",
			}}
		>
			<div
				style={{
					display: "flex",
					flexDirection: "column",
					justifyContent: "center",
					alignItems: "center",
					flex: 1,
				}}
			>
				<h1 style={styles.title}>Сорви джекпот</h1>
				<div style={styles.slots.title.count}>
					<span style={{ transform: "skew(30deg)", display: "block" }}>
						Вращений: <span style={{ color: "#D71015" }}>{3 - count}</span>
					</span>
				</div>
				{/* <div style={styles.slots.title}>Hot fruit</div> */}
				<div style={styles.slots}>
					{/* <img
						style={{ margin: "auto", display: "block" }}
						src={title_slots}
						alt={"title slot"}
					/> */}

					<div
						style={{
							...styles.slots.col,
							top: xs
								? SLOTS_RESPONSE.mobile.slot[0].top
								: SLOTS_RESPONSE.desktop.slot[0].top,
							left: xs
								? SLOTS_RESPONSE.mobile.slot[0].left
								: SLOTS_RESPONSE.desktop.slot[0].left,
						}}
					>
						<div
							ref={slots1}
							style={{
								width: xs
									? SLOTS_RESPONSE.mobile.slot_width
									: SLOTS_RESPONSE.desktop.slot_width,
								hight: "auto",
								transform: xs ? "translateY(-396px)" : "translateY(-835px)",
								alignItems: "center",
								display: "flex",
								flexDirection: "column",
								gap: xs
									? SLOTS_RESPONSE.mobile.gap
									: SLOTS_RESPONSE.desktop.gap,
							}}
						>
							{slotArr[0].reverse().map((item, i) => {
								return (
									<img
										src={item}
										height={
											xs
												? SLOTS_RESPONSE.mobile.img.h
												: SLOTS_RESPONSE.desktop.img.h
										}
										width={
											xs
												? SLOTS_RESPONSE.mobile.img.w
												: SLOTS_RESPONSE.desktop.img.w
										}
										key={i}
										alt={"slot"}
									/>
								);
							})}
						</div>
					</div>
					<div
						style={{
							...styles.slots.col,
							top: xs
								? SLOTS_RESPONSE.mobile.slot[1].top
								: SLOTS_RESPONSE.desktop.slot[1].top,
							left: xs
								? SLOTS_RESPONSE.mobile.slot[1].left
								: SLOTS_RESPONSE.desktop.slot[1].left,
						}}
					>
						<div
							ref={slots2}
							style={{
								width: xs
									? SLOTS_RESPONSE.mobile.slot_width
									: SLOTS_RESPONSE.desktop.slot_width,
								hight: "auto",
								transform: xs ? "translateY(-396px)" : "translateY(-835px)",
								alignItems: "center",
								display: "flex",
								flexDirection: "column",
								gap: xs
									? SLOTS_RESPONSE.mobile.gap
									: SLOTS_RESPONSE.desktop.gap,
							}}
						>
							{slotArr[1].reverse().map((item, i) => {
								return (
									<img
										src={item}
										height={
											xs
												? SLOTS_RESPONSE.mobile.img.h
												: SLOTS_RESPONSE.desktop.img.h
										}
										width={
											xs
												? SLOTS_RESPONSE.mobile.img.w
												: SLOTS_RESPONSE.desktop.img.w
										}
										key={i}
										alt={"slot"}
									/>
								);
							})}
						</div>
					</div>
					<div
						style={{
							...styles.slots.col,
							top: xs
								? SLOTS_RESPONSE.mobile.slot[2].top
								: SLOTS_RESPONSE.desktop.slot[2].top,
							right: xs
								? SLOTS_RESPONSE.mobile.slot[2].right
								: SLOTS_RESPONSE.desktop.slot[2].right,
						}}
					>
						<div
							ref={slots3}
							style={{
								width: xs
									? SLOTS_RESPONSE.mobile.slot_width
									: SLOTS_RESPONSE.desktop.slot_width,
								hight: "auto",
								transform: xs ? "translateY(-396px)" : "translateY(-835px)",
								alignItems: "center",
								display: "flex",
								flexDirection: "column",
								gap: xs
									? SLOTS_RESPONSE.mobile.gap
									: SLOTS_RESPONSE.desktop.gap,
							}}
						>
							{slotArr[2].reverse().map((item, i) => {
								return (
									<img
										src={item}
										height={
											xs
												? SLOTS_RESPONSE.mobile.img.h
												: SLOTS_RESPONSE.desktop.img.h
										}
										width={
											xs
												? SLOTS_RESPONSE.mobile.img.w
												: SLOTS_RESPONSE.desktop.img.w
										}
										key={i}
										alt={"slot"}
									/>
								);
							})}
						</div>
					</div>
				</div>
				<div
					style={styles.slots.btn}
					onClick={stopAnim}
					className={"btn-slots"}
				>
					{/* Забрать бонус
					 */}
					Остановить
				</div>
			</div>
			<Modal
				style={{
					...(isOpenModal ? styles.slots.modal.modalOpen : styles.slots.modal),
				}}
				type={count}
				onHandlerClickModal={() => {
					if (count < 3) {
						slots1.current.style.transform = xs
							? "translate-y(-396px)"
							: "translate-y(-835px)";
						slots2.current.style.transform = xs
							? "translate-y(-396px)"
							: "translate-y(-835)";
						slots3.current.style.transform = xs
							? "translate-y(-396px)"
							: "translate-y(-835px)";
						setOpenModal(false);
						animsPlay();
					} else {
						window.location = "https://ya.ru";
					}
				}}
			/>
		</div>
	);
}

export default Slots;
